import { Alert, AlertTitle } from "@mui/material";
import React, { useState } from "react";
import { RxCrossCircled } from "react-icons/rx";
import { TfiDownload } from "react-icons/tfi";

const DownloadImages = ({ inspectionData, onClose }) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);
  const [downloadProgress, setDownloadProgress] = useState(0);

  const downloadImages = async () => {
    try {
      setDownloading(true);
      setError(null);
      const imageUrls = inspectionData.images || [];

      if (imageUrls.length === 0) {
        throw new Error("No images available for download");
      }
      for (let i = 0; i < imageUrls.length; i++) {
        try {
          const response = await fetch(imageUrls[i]);
          if (!response.ok)
            throw new Error(`Failed to download image ${i + 1}`);

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `inspection-image-${i + 1}.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          setDownloadProgress(((i + 1) / imageUrls.length) * 100);
        } catch (err) {
          console.error(`Error downloading image ${i + 1}:`, err);
          throw new Error(`Failed to download image ${i + 1}`);
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-lg">
      <RxCrossCircled
        onClick={onClose}
        className="float-end top-2 h-6 w-6 cursor-pointer"
      />
      <div className="flex items-center justify-center mb-6 mt-4">
        <h2 className="text-xl font-semibold text-gray-800 p-4">
          Are you sure want to Download
        </h2>
      </div>

      {error && (
        <Alert variant="destructive" className="mb-4">
          <AlertTitle>{error}</AlertTitle>
        </Alert>
      )}

      {downloading && (
        <div className="mb-2">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${downloadProgress}%` }}
            />
          </div>
          <p className="text-sm text-gray-600 mt-2">
            Downloading... {Math.round(downloadProgress)}%
          </p>
        </div>
      )}
      <div className="flex space-x-4">
        <button
          onClick={downloadImages}
          disabled={downloading}
          className="w-full flex items-center justify-center px-4 py-2 bg-[#1C3664] text-white rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200"
        >
          <TfiDownload className="mr-2" />
          {downloading ? "Downloading..." : "Yes"}
        </button>
        <button
          onClick={onClose}
          className="w-full flex items-center justify-center px-4 py-2 bg-slate-300 text-black border border-solid border-black rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200"
        >
          No
        </button>
      </div>
    </div>
  );
};

export default DownloadImages;
